import { useState } from "react";
import './form.css'

const Form = (props) => {
    const [item, setItem] = useState("");
    function getValue(e){
        setItem(e.target.value)
    }
    const handleSubmit = (e) => {
        props.addDo(item);
        setItem("");
        e.preventDefault();
    }
    
    return(
        <div className="Form">
            <form>
                <div className="inp_con_dark" >
                    <span className="circle" ></span>
                    <input type="text" name="item" onChange={getValue} value={item} />
                </div>
                <button type="submit" onClick={handleSubmit}>submit</button>
            </form>
        </div>
    )
}

export default Form;